import { render, staticRenderFns } from "./dealerStock.vue?vue&type=template&id=58b45cc0&scoped=true"
import script from "./dealerStock.vue?vue&type=script&lang=js"
export * from "./dealerStock.vue?vue&type=script&lang=js"
import style0 from "./dealerStock.vue?vue&type=style&index=0&id=58b45cc0&scoped=true&lang=scss"
import style1 from "./dealerStock.vue?vue&type=style&index=1&id=58b45cc0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b45cc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58b45cc0')) {
      api.createRecord('58b45cc0', component.options)
    } else {
      api.reload('58b45cc0', component.options)
    }
    module.hot.accept("./dealerStock.vue?vue&type=template&id=58b45cc0&scoped=true", function () {
      api.rerender('58b45cc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/dealerStock.vue"
export default component.exports